import { Spinner } from 'flowbite-react'; 

/**
 * A full-screen loading overlay to display during initial page load.
 */
const FullScreenLoader = () => {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 dark:bg-gray-900">
      <Spinner size="xl" color="purple" />
    </div>
  );
};

export default FullScreenLoader;